import * as React from "react";
import { t } from "i18next";
import { MultiStepTask } from "src/components/MultiStepTask";
import { MultiStepItem } from "src/components/MultiStepTask/MultiStepItem";
import { lastStep, nextStep } from "src/components/MultiStepTask/utils";
import { observer } from "mobx-react-lite";
import { MultiStepEntsTable } from "src/components/MultiStepTask/utils/MultiStepEntsTable";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { Spin } from "antd";
import { Mc2CopyToStore } from "./Mc2CopyToStore";

interface PropsMc2CopyTo {
  store: Mc2CopyToStore;
}

export const Mc2CopyTo: React.FC<PropsMc2CopyTo> = observer((props) => {
  const { store } = props;
  const { store1 } = store;
  const steps: MultiStepItem[] = [
    {
      title: "Модель",
      description: "Выберите экземпляр для копирования выбранных ранее строк",
      next: nextStep(store.firstDisabled),
      drawContent: () =>
        store1 ? (
          <MultiStepEntsTable>
            <EntityFiltersTable store={store1} />,
          </MultiStepEntsTable>
        ) : (
          <Spin />
        ),
    },
    lastStep(t("Copying"), store.copyInfo, () => store.copy()),
  ];
  return (
    <MultiStepTask
      title={t("Copy to")}
      taskStore={store.taskStore}
      steps={steps}
    />
  );
});
